import { create } from "zustand";
import { persist } from "zustand/middleware";

export type BranchCheckoutMode = "transfer" | "block";

export type BranchCheckoutChoice = {
	mode: BranchCheckoutMode;
	hideConfirmation: boolean;
};

type BranchCheckoutSettingsStore = BranchCheckoutChoice & {
	setMode: (mode: BranchCheckoutMode) => void;
	setChoice: (choice: BranchCheckoutChoice) => void;
};

export const useBranchCheckoutSettingsStore = create<BranchCheckoutSettingsStore>()(
	persist(
		(set) => ({
			mode: "transfer",
			hideConfirmation: false,
			setMode: (mode) => set({ mode }),
			setChoice: ({ mode, hideConfirmation }) => set({ mode, hideConfirmation }),
		}),
		{ name: "branch-checkout-settings" },
	),
);
